import {
	ChangeDetectionStrategy,
	Component,
	DestroyRef,
	DOCUMENT,
	Inject,
	inject,
	OnInit,
	signal,
} from '@angular/core';
import { RouterOutlet } from '@angular/router';
import {
	AbstractConfigService,
	AlarisLanguageService,
	AlarisThemeType,
	CONFIG_SERVICE_INJECTOR,
	LANGUAGE_SERVICE_INJECTOR,
} from '@campaign-portal/components-library';
import { environment } from 'src/environments/environment';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss'],
	imports: [RouterOutlet],
	standalone: true,
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit {
	readonly environment = environment;
	readonly fadeIn = signal(false);
	readonly animationState = signal('');
	private readonly destroyRef = inject(DestroyRef);

	constructor(
		@Inject(LANGUAGE_SERVICE_INJECTOR) private readonly lang: AlarisLanguageService,
		@Inject(CONFIG_SERVICE_INJECTOR) private readonly config: AbstractConfigService,
		@Inject(DOCUMENT) private readonly document: Document
	) {
		this.lang = lang;
	}

	ngOnInit(): void {
		this.lang.restore();
		this.config.themeType$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((type) => this.applyPrismTheme(type));
	}

	applyPrismTheme(type: AlarisThemeType): void {
		const link = this.document.getElementById('prism-theme') as HTMLLinkElement | undefined;
		if (link) {
			const theme = type === 'light' ? 'prism' : 'prism-okaidia';
			link.href = `styles/prism-theme/${theme}.min.css`;
		}
	}

	prepareRoute(outlet: RouterOutlet): string | undefined {
		return outlet?.activatedRouteData?.animationState;
	}

	resetFadeIn($event: AnimationEvent): void {
		if ($event.animationName.endsWith('app-fade-in')) {
			this.fadeIn.set(false);
		}
	}

	updateAnimationState(outlet: RouterOutlet): void {
		const currentState = this.animationState();
		const updatedState = outlet?.activatedRouteData?.animationState || '';
		const fadeIn =
			(currentState === 'SignInLayoutComponent' && updatedState === 'MainLayoutComponent') ||
			(currentState === 'MainLayoutComponent' && updatedState === 'SignInLayoutComponent');
		this.fadeIn.set(fadeIn);
		this.animationState.set(updatedState);
	}
}
